import { render, staticRenderFns } from "./Logging.vue?vue&type=template&id=1198b615"
import script from "./Logging.vue?vue&type=script&lang=js"
export * from "./Logging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports